module.exports = __webpack_public_path__ + "/images/shop/icon/windshield_wipers.svg";